import Logo from "../../assets/images/BX-LOGO.svg";
import {Link, useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {verifyEmail} from "../../api/api";
import {toast} from "react-toastify";


function VerifyEmailPage(props) {
    let { token } = useParams();
    const shouldMutate = useRef(true)
    const [message, setMessage] = useState()

    const verifyEmailMutation = useMutation({
        mutationFn: verifyEmail,
        onSuccess: (data, variables) =>{
            setMessage(data.email)
            toast.success('Email Address Verified!')
        },
        // retry: true,
        // onError: (err, variables) => {
        //     handleUnauthorized401MutateError(err, refreshToken, addProductMutation, variables)
        //     if(err.response.status !== 401){
        //         toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        //     }
        // }
        onError: (err) => {
            setMessage(err.response.data.error)
            toast.error(err.response.data.error)
        }
    })

    // console.log('verifyEmailMutation.error.response.data.error', verifyEmailMutation.error.response.data.error)

    useEffect(() => {
        // shouldMutate.current is implemented to fix useEffect runs twice after React v18
        if(shouldMutate.current){
            shouldMutate.current = false
            verifyEmailMutation.mutate({token:token})
        }
    }, [token, verifyEmailMutation]);

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">

                                <div className="card-body p-4">

                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                    </div>

                                    <div className="mt-3 text-center">

                                        <h4>{message}</h4>

                                        <Link to={'/login'}
                                              className="btn btn-block bx-btn-primary waves-effect waves-light mt-3">Go to Login</Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VerifyEmailPage;